import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Checkbox, Confirm, Popup } from "semantic-ui-react";
import {
  deletePlan,
  handlePriceShow,
} from "../../store/actions/athleteActions";
const PlanCard = ({ plan, editFlag, editId, nextHandler, onSignUp, hide }) => {
  const [confirm, setConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const dispatch = useDispatch();
  return (
    <div className="price-table">
      <div className="price">
        <small>$</small>
        {plan.amount * 0.01}
      </div>
      <h2 className="title">
        {plan.otp ? "Service Fee" : `${plan.months} Months`}
      </h2>

      {plan.otp ? (
        <p className="description">{plan.description}</p>
      ) : (
        <p className="description">
          Available for {plan.classYear}+<br />
          {plan.description}
        </p>
      )}

      <div className="buttons-div">
        {!onSignUp && !hide && (
          <>
            <div>
              <Popup
                trigger={
                  <Checkbox
                    toggle
                    defaultChecked={plan.show}
                    onChange={(e, data) => {
                      dispatch(handlePriceShow(plan.planId, data.checked));
                    }}
                  />
                }
                content={`Click Here To ${!plan.show ? "Active" : "Inactive"}`}
                size="small"
              />
            </div>
            <div>
              <Button
                icon="pencil"
                circular
                color="black"
                basic
                onClick={() => {
                  editFlag();
                  editId();
                }}
              />
              <Button
                icon="trash"
                circular
                color="red"
                basic
                onClick={() => {
                  setConfirm(true);
                  setDeleteId(plan.planId);
                }}
              />
            </div>
          </>
        )}
      </div>
      {onSignUp && !hide && (
        <Button color="blue" onClick={() => nextHandler(plan)}>
          Select
        </Button>
      )}
      <Confirm
        open={confirm}
        content="You Sure Want To Delete ?"
        onCancel={() => {
          setConfirm(false);
          setDeleteId(null);
        }}
        onConfirm={() => {
          dispatch(deletePlan(deleteId));
          setConfirm(false);
          setDeleteId(null);
        }}
      />
    </div>
  );
};

export default PlanCard;
